export default class Colors {
	static dark = {
		black: '#000000',
		blue: '#0000ff',
		brown: '#a52a2a',
		darkblue: '#00008b',
		darkcyan: '#008b8b',
		darkgrey: '#4c4c4c',
		darkgreen: '#006400',
		darkkhaki: '#460b00',
		darkmagenta: '#8b008b',
		darkolivegreen: '#004a2c',
		darkorange: '#ff8c00',
		darkorchid: '#9932cc',
		darkred: '#8b0000',
		darksalmon: '#5c3a2e',
		darkviolet: '#9400d3',
		fuchsia: '#ff00ff',
		green: '#008000',
		indigo: '#4b0082',
		darkkhakitwo: '#6f6941',
		maroon: '#800000',
		navy: '#000080',
		someDarkBlue: '#002c34',
		anotherdarkorange: '#402000',
		purple: '#800080',
		violet: '#800080',
		red: '#ff0000',
		silver: '#4e4e4e',
	};

	static bright = {
		lime: '#00ff00',
		aqua: '#00ffff',
		azure: '#f0ffff',
		beige: '#f5f5dc',
		lightblue: '#add8e6',
		lightcyan: '#e0ffff',
		lightgreen: '#90ee90',
		lightgrey: '#d3d3d3',
		lightpink: '#ffb6c1',
		lightyellow: '#ffffe0',
		magenta: '#ff00ff',
		pink: '#ffc0cb',
		cyan: '#00ffff',
		white: '#ffffff',
		yellow: '#ffff00'
	};

	static getBrightColo(index) {
		index = index - 1;
		var keys = Object.keys(Colors.bright);
		const selectedKey = keys[index % (keys.length)];
		return Colors.bright[selectedKey];
	}

	constructor(id) {
		this.type = 'DARK';
		this.id = id;
	}

	static getDarkColor(index) {
		index = index - 1;
		if(index < 0) {
			index = 0;
		}
		var keys = Object.keys(Colors.dark);
		const selectedKey = keys[index % (keys.length)];
		return Colors.dark[selectedKey];
	}

	static getDarkColorRgba(index, opacity = '1') {
		let c = null;
		const hex = Colors.getDarkColor(index);
		if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
			c = hex.substring(1).split('');
			if(c.length === 3) {
				c = [c[0], c[0], c[1], c[1], c[2], c[2]];
			}
			c = '0x' + c.join('');
			return `rgba( ${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')} , ${opacity})`;
		}
		throw new Error('Bad Hex');
	}

	rgb() {
		return Colors.getDarkColor(this.id);
	}

	rgba(opacity = '1') {
		return Colors.getDarkColorRgba(this.id, opacity);
	}

	toString() {
		return this.rgb();
	}
}